import {
  apiFetch,
  apiPost,
  apiPut,
  apiPatch,
  apiDelete,
} from '@/utils/fetchWrapper';
import {
  buildDetectedKeywordHistoryQueryString,
  buildMonitoredWordsQueryString,
  buildPaginatedPath,
} from '@/utils/queryParams';
import {
  PaginatedMonitoredWordsResponse,
  MonitoredWordsFilters,
  MonitoredWord,
  CreateMonitoredWordRequest,
  UpdateMonitoredWordRequest,
  BulkUploadRequest,
  BulkUploadResponse,
  PaginatedDetectedKeywordHistoryResponse,
  DetectedKeywordHistoryFilters,
} from '@/types/keywords';

export const keywordsService = {
  async getMonitoredWords(
    filters: MonitoredWordsFilters = {}
  ): Promise<PaginatedMonitoredWordsResponse> {
    const url = buildPaginatedPath(
      '/monitored_words/',
      buildMonitoredWordsQueryString(filters)
    );
    return apiFetch<PaginatedMonitoredWordsResponse>(url);
  },

  async getMonitoredWord(id: number): Promise<MonitoredWord> {
    return apiFetch<MonitoredWord>(`/monitored_words/${id}/`);
  },

  async createMonitoredWord(
    wordData: CreateMonitoredWordRequest
  ): Promise<MonitoredWord> {
    return apiPost<MonitoredWord>('/monitored_words/', wordData);
  },

  async updateMonitoredWord(
    id: number,
    wordData: UpdateMonitoredWordRequest
  ): Promise<MonitoredWord> {
    return apiPut<MonitoredWord>(`/monitored_words/${id}/`, wordData);
  },

  async patchMonitoredWord(
    id: number,
    wordData: Partial<UpdateMonitoredWordRequest>
  ): Promise<MonitoredWord> {
    return apiPatch<MonitoredWord>(`/monitored_words/${id}/`, wordData);
  },

  async deleteMonitoredWord(id: number): Promise<void> {
    return apiDelete(`/monitored_words/${id}/`);
  },

  async bulkUpload(
    uploadData: BulkUploadRequest
  ): Promise<BulkUploadResponse> {
    const formData = new FormData();
    formData.append('file', uploadData.file);

    if (uploadData.is_active !== undefined) {
      formData.append('is_active', uploadData.is_active.toString());
    }
    if (uploadData.auto_terminate !== undefined) {
      formData.append('auto_terminate', uploadData.auto_terminate.toString());
    }

    return apiPost<BulkUploadResponse>('/monitored_words/bulk-upload/', formData);
  },

  async getDetectedKeywordHistory(
    filters: DetectedKeywordHistoryFilters = {}
  ): Promise<PaginatedDetectedKeywordHistoryResponse> {
    const url = buildPaginatedPath(
      '/word_detections/',
      buildDetectedKeywordHistoryQueryString(filters)
    );
    return apiFetch<PaginatedDetectedKeywordHistoryResponse>(url);
  },
};
